import { Heading, Stack, Text } from "@chakra-ui/react";

import CustomLink from "components/Chakra/CustomLink";
import IconRightArrow from "components/Chakra/Icons/RightArrow";

type CardProps = {
  title: string;
  subTitle: string;
  buttonText?: string;
};
const Card = ({ buttonText, subTitle, title }: CardProps) => (
  <Stack
    bgColor="ud-grey-light"
    flex={1}
    p={{ base: "16px", lg: "32px" }}
    spacing={0}
    gap="16px"
    cursor="auto"
  >
    <Heading
      fontWeight="bold"
      fontSize={{ base: "20px", lg: "24px" }}
      lineHeight="28px"
    >
      {title}
    </Heading>
    <Text fontWeight={400} flex={1}>
      {subTitle}
    </Text>
    {buttonText && (
      <CustomLink
        href="https://my.matterport.com/show/?m=U9DXoKMmBDD"
        display="flex"
        alignItems="center"
        justifyContent="center"
        gap={1}
        borderRadius="full"
        border="1px solid"
        borderColor="ud-grey-dark"
        backgroundColor="inherit"
        color="ud-grey-dark"
        p="6px 12px"
        fontSize="14px"
        w="fit-content"
        sx={{
          _hover: {
            backgroundColor: "ud-grey-dark",
            color: "ud-white",
            svg: {
              fill: "ud-white",
            },
          },
        }}
      >
        {buttonText}
        <IconRightArrow />
      </CustomLink>
    )}
  </Stack>
);

export default Card;
